import { Eye, FileDown, Send, Star } from "lucide-react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { catchAsync, checkDecimal, successTheme } from "src/helpers";
import { getProjectDetailsRootState } from "src/redux/reducers/projectDetailsSlice";
import { setShowLoginModule } from "src/redux/reducers/tempDataSlice";
import { RootState } from "src/redux/store";
import { addToWishlistRequestApi } from "src/services/requests/Wishlist";
import RoundedButton from "src/shadcn/components/custom/RoundedButton";
import { useAuth } from "../Auth/Core";
import EnquiryRequestDialog from "../EnquiryForms/EnquiryRequestDialog";
import RenderData from "./RenderData";
import { MAIN_ROUTES_CONST } from "src/navigations/modules";
import CustomeDialog from "src/shadcn/components/custom/CustomeDialog";

type Props = {};

const ProjectLeftDetails = ({ }: Props) => {
  const { project_details: projectDetails } = useSelector((state: RootState) => getProjectDetailsRootState(state));
  const { currentUser } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showEnquiryDailog, setshowEnquiryDailog] = useState<boolean>(false);
  const [openSiteMapDiaglog, setOpenSiteMapDiaglog] = useState<boolean>(false)

  const [isLoading, setisLoading] = useState(false);

  const handleAddToWishlist = catchAsync(
    async () => {
      setisLoading(true);
      return (
        currentUser?.id &&
        projectDetails?._id &&
        (await addToWishlistRequestApi({
          userId: currentUser?.id,
          projectId: projectDetails?._id,
        }))
      );
    },
    (result: any) => {
      setisLoading(false);
      if (result?.status == 201) {
        toast.success("Registration successful,OTP sent on you email.", {
          style: successTheme,
        });
      }
    },
    () => {
      setisLoading(false);
    }
  );

  return (
    <div className="space-y-2">
      <div className=" uppercase text-gray-400 border-primary border-b-2 py-2 text-sm ">
        Project ID : <span className="font-bold"># {projectDetails?.project_id}</span>
      </div>
      <div className="grid grid-cols-2 gap-4 py-2">
        <img
          src={projectDetails?.imageAttachments ? projectDetails?.imageAttachments[0] : null}
          style={{ width: "100%", height: "150px" }}
        />
        <div className="flex flex-col space-y-2">
          <div className="text-gray-400">Sell Price</div>
          <div className="flex space-x-2 text-sm">
            <span className="flex mx-2">
              ₹ <RenderData value={projectDetails?.projectCost ? checkDecimal(projectDetails?.projectCost, true) : 0} />{" "}
            </span>{" "}
            <span>(Excl. VAT)</span>
          </div>
        </div>
      </div>
      <div className=" uppercase text-gray-400 border-primary border-b-2  py-2 text-sm ">Advertisement activity</div>
      <div className="flex space-x-2">
        <div className="flex flex-1 space-x-2 items-center border  p-2 text-xs">
          <Eye size={16} className="text-gray-400" />
          <span>View :</span>
          <span></span>
        </div>
        <div className="flex flex-1 space-x-2 items-center border  p-2 text-xs">
          <Star size={16} className="text-gray-400" />
          <span>On wish list :</span>
          <span>45</span>
        </div>
      </div>
      <div className="flex flex-col space-y-2">
        <div className="flex space-x-1 mx-4">

          {!currentUser ? (
            <RoundedButton className="flex-1 text-sm " onClick={() => navigate("/" + MAIN_ROUTES_CONST.login)}>
              Display Project Data
            </RoundedButton>
          ) : null}
          {projectDetails?.projectDocument ?
            <RoundedButton variant={'outline'} className="flex-1 text-sm space-x-2 " onClick={() => {
              window.open(projectDetails?.projectDocument, "_blank", "noopener,noreferrer");
            }}>
              <span>Project Document</span> <FileDown size={20} />
            </RoundedButton> : <></>
          }
        </div>
        {
          <div className="flex flex-col space-y-2">
            <div className="flex space-x-2 mx-4">
              <RoundedButton
                variant={'outline'}
                // disabled={!currentUser?.id}
                onClick={() => {
                  if (!currentUser) {
                    navigate("/login");
                  }
                  handleAddToWishlist();
                }}
                isLoading={isLoading}
                className="flex-1 space-x-2 text-sm"
              >
                {" "}
                <Star size={16} className="text-white" />
                <span>Add to wish list</span>
              </RoundedButton>
              {
                // projectDetails?.siteMapLink && 
                <RoundedButton
                  variant={'outline'}
                  // disabled={!currentUser?.id}
                  onClick={() => {
                    window.open(projectDetails?.siteMapLink, "_blank", "noopener,noreferrer");
                    // setOpenSiteMapDiaglog(true)
                  }}
                  isLoading={isLoading}
                  className="flex-1 space-x-2 text-sm"
                >
                  {" "}
                  <span>Open Site Map</span>
                </RoundedButton>
              }
            </div>
            <RoundedButton
              onClick={() => {
                setshowEnquiryDailog(true);
              }}
              variant={"outline"}
              className="flex-1 space-x-2 text-sm mx-4"
            >
              {" "}
              <Send size={16} />
              <span>Send Enquiry</span>
            </RoundedButton>
          </div>
        }
      </div>
      {/* <EnquiryFormDialog openState={showEnquiryDailog} isOpenState={(e: any) => {  setshowEnquiryDailog(e) }} /> */}
      <EnquiryRequestDialog
        openState={showEnquiryDailog}
        isOpenState={(e: any) => {
          setshowEnquiryDailog(e);
        }}
        initValues={{
          userid: currentUser?.id,
          project_id: projectDetails?._id,
          project_type: projectDetails?.projectType,
        }}
      />
      <CustomeDialog className="md:max-w-[100vw] h-[90vh]" isOpen={openSiteMapDiaglog} headerTitle={'Site Map'} hideDefaultSubmit onCancle={() => setOpenSiteMapDiaglog(false)}  >
        <iframe src={projectDetails?.siteMapLink} style={{width:"100vw" , height:"75vh",paddingBottom:"10px"}} />
      </CustomeDialog>
    </div>
  );
};

export default ProjectLeftDetails;
